import styled from 'styled-components';

export const Container = styled.div`
	margin: 0 auto;
`;

export const Title = styled.div`
	font-size: 32px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
	margin-top: 32px;
`;

export const Description = styled.div`
	font-size: 18px;
	color: ${({ theme }) => theme.colors.text.body};
	margin-top: 12px;
`;

export const TabsWrapper = styled.div`
  margin-top: 32px;
`;
